import { useEffect } from 'react';
import { useFirstMountState } from '../useFirstMountState/index.js';
import { noop } from '../util/const.js';
export function useUpdateEffect(effect, deps) {
    const isFirstMount = useFirstMountState();
    useEffect(isFirstMount ? noop : effect, deps);
}
